import { useQuery } from '@tanstack/react-query';
import { refereeQuestionService } from '../services/referee-question.service';
import type { RefereeQuestion } from '../types/referee-question.types';

export function useCompanyQuestions(companyId: string): {
  questions: RefereeQuestion[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ['company-questions', companyId],
    queryFn: () => refereeQuestionService.listCompanyQuestions(companyId),
    enabled: Boolean(companyId),
  });

  return {
    questions: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
